export const sections = [
    {
        title: "Navigating within the website",
        content: [
            {
                type: "text",
                content: "A. Navigation across pages",
                styling: "subheader"
            },
            {
                type: "text",
                content: "Different pages of the SAFEPATH website can be accessed by clicking on the top navigation titles.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "navigation_across.jpg"
            },
            {
                type: "text",
                content: "B. Returning to homepage",
                styling: "subheader"
            },
            {
                type: "text",
                content: "The SAFEPATH logo on the top right can be clicked on any page to return to the homepage of the Database website.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "navigation_home.jpg"
            },
        ]
    },
    {
        title: "Measures page",
        content: [
            {
                type: "text",
                content: "The measures page of the website contains the database of measures to increase highway capacity. The user interface features the following elements:",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "homepage.jpg"
            },
            {
                type: "orderedList",
                listItems: [
                    {number: "1", text: "Link to the CEDR website."},
                    {number: "2", text: "Return to the Homepage of the SAFEPATH Database website from any location."},
                    {number: "3", text: "Links to navigate between different pages of the website"},
                    {number: "4", text: "Tools to search and filter measures."},
                    {number: "5", text: "An interactive list of all the (filtered) measures. "},
                    {number: "6", text: "An interactive map to filter measures based on the selected country."},
                ]
            },
        ]
    },
    {
        title: "Changing the layout within measures page",
        content: [
            {
                type: "text",
                content: "The map can be hidden to show a bigger list of measures with more details. This can be done using the hide map button (>) within the map window.",
                styling: "paragraph",
            },
            {
                type: "image",
                image: "layout_hide_map.jpg"
            },
            {
                type: "text",
                content: "To show the map again, press the view map button.",
                styling: "paragraph",
            },
            {
                type: "image",
                image: "layout_show_map.jpg"
            },
        ]
    },
    {
        title: "Navigating within the map",
        content: [
            {
                type: "text",
                content: "The map can be zoomed in or out using the +/- button on the map (or by scrolling up or down).",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "map_controls.jpg"
            },
            {
                type: "text",
                content: "To pan around the map, click and hold the cursor and move in the desired direction.",
                styling: "paragraph"
            }
        ]
    },
    {
        title: "Using the database of measures",
        content: [
            {
                type: "text",
                content: "The database contains a wide variety of measures. There are tools in the website to filter or search for a particular (type of) measure.",
                styling: "paragraph"
            },
            {
                type: "text",
                content: "A. Filtering by type of measure",
                styling: "subheader"
            },
            {
                type: "text",
                content: "The measures of a particular category can be filtered by using the category drop-down lists on the “Measures” page of the website. There are three subdivisions namely: Category, Sub-category and Type of measure. The measures can be filtered by selecting one of the elements from each drop-down list.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_filter_type_1.jpg",
            },
            {
                type: "text",
                content: "Once a category is selected, the measures in the list get updated automatically conforming to the category selected on the filters.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_filter_type_2.jpg",
            },
            {
                type: "text",
                content: "Depending upon the chosen filter, the content of other filters also gets adjusted automatically, depending upon the availability of measures within the database. For example, when the “Vehicle technology” category is selected, the subcategory filter automatically displays content relevant to the vehicle technology measures.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_autocomplete_1.jpg",
            },
            {
                type: "text",
                content: "In a similar way, all three filters can be defined to narrow down the listed measures to desired category, subcategory and type of measure.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_autocomplete_2.jpg",
            },
            {
                type: "text",
                content: "To remove the category filter, click on the cross sign (X) next to the selected category.",
                styling: "paragraph"
            },
            {
                type: "text",
                content: "B. Filtering by the name of the measure",
                styling: "subheader"
            },
            {
                type: "text",
                content: "The user can search for a  specific measure by its name using the search measure tool in the database website. ",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_filter_name.jpg",
            },
            {
                type: "text",
                content: "By clicking on the text field, the user can start typing the measure name. The searching is real-time and results are dynamically listed in the form of a drop-down under the search command. Users can select a measure from the drop-down of the seach command.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_filter_related.jpg",
            },
            {
                type: "text",
                content: "Once a measure is selected from the drop-down of the search command, the related measures are updated in the list next to the map.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_filter_clear.jpg",
            },
            {
                type: "text",
                content: "To remove the search filter, click on the cross sign (X) next to the name of the measure in the search bar.",
                styling: "paragraph"
            },
            {
                type: "text",
                content: "C. Filtering the measures based on country",
                styling: "subheader"
            },
            {
                type: "text",
                content: "The map tool on the home page of the website enables the users to filter the measures based on a country selection. Hovering the cursor over the country shows how many measures are listed for that country. ",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_filter_map_1.jpg",
            },
            {
                type: "text",
                content: "Once a country is selected from the map, the measures falling under the country are shown in the list. The highlighted country can be recognized by its thick black borders.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_filter_map_2.jpg",
            },
            {
                type: "text",
                content: "To remove the country filter, click on any empty space (ocean) within the map.",
                styling: "paragraph"
            },
            {
                type: "text",
                content: "D. Combination of filters",
                styling: "subheader"
            },
            {
                type: "text",
                content: "Various filters such as categories, searching measures, and country selection can be combined together to find a particular measure belonging to a country. ",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "measures_filter_combine.jpg",
            },
        ]
    },
    {
        title: "Viewing measure details",
        content: [
            {
                type: "text",
                content: "Selecting a measure in the list opens the details about that measure."
            },
            {
                type: "image",
                image: "measure_viewing.jpg"
            }
        ]
    },
    {
        title: "Viewing statistics",
        content: [
            {
                type: "text",
                content: "To get the statistics of the measures in the database, use the summary statistics tab of the list. ",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "statistics_1.jpg"
            },
            {
                type: "text",
                content: "You can also select a country on the map to view the statistics of that country.",
                styling: "paragraph"
            },
            {
                type: "image",
                image: "statistics_2.jpg"
            },
        ]
    }
]